import { CIcon } from '~/icons/types'
export const ciOdometer: CIcon = {
  width: 512,
  height: 425.1,
  paths: [
    {
      d:
        'M501.1 245h-12.3c-2.4-54.7-23.7-106-60.9-146.5l8.8-8.8c4.1-4.1 4.1-10.7 0-14.8-4.1-4.1-10.7-4.1-14.8 0l-8.8 8.8c-40.6-37.2-91.9-58.5-146.6-60.9V10.5C266.5 4.7 261.8 0 256 0s-10.5 4.7-10.5 10.5v12.3c-54.8 2.4-106.2 23.7-146.7 60.7l-8.7-8.7c-4.1-4.1-10.7-4.1-14.8 0-4.1 4.1-4.1 10.7 0 14.8l8.7 8.7C47 138.8 25.7 190.2 23.2 245H10.9C5.1 245 .4 249.7.4 255.5S5.1 266 10.9 266h12.3c2.1 47.6 18.4 92.6 47.4 130.7 13.5 17.8 35.1 28.4 57.8 28.4h255.2c22.7 0 44.3-10.7 57.9-28.6 28.9-38 45.2-82.9 47.2-130.5H501c5.8 0 10.5-4.7 10.5-10.5s-4.6-10.5-10.4-10.5zm-76.3 138.8c-9.7 12.7-25.1 20.3-41.2 20.3H128.4c-16.1 0-31.5-7.5-41.1-20.1-26.2-34.4-41-74.9-43-117.9h10.4c5.8 0 10.5-4.7 10.5-10.5s-4.7-10.5-10.5-10.5H44.3c2.4-50.6 22.7-96.6 54.6-131.8l20.1 20.1c2.1 2.1 4.7 3.1 7.4 3.1s5.4-1 7.4-3.1c4.1-4.1 4.1-10.7 0-14.8l-20.1-20.1c35.3-32 81.2-52.2 131.8-54.7v10.4c0 5.8 4.7 10.5 10.5 10.5s10.5-4.7 10.5-10.5V43.8c49.1 2.4 95.2 21.5 131.7 54.7l-20.1 20.1c-4.1 4.1-4.1 10.7 0 14.8 2.1 2 4.7 3.1 7.4 3.1s5.4-1 7.4-3.1l20.1-20.1c33.2 36.5 52.3 82.6 54.7 131.7h-10.4c-5.8 0-10.5 4.7-10.5 10.5s4.7 10.5 10.5 10.5h10.4c-2 42.9-16.8 83.5-42.9 117.8z'
    },
    {
      d:
        'm339.7 156.9-57.5 57.6c-7.6-4.8-16.5-7.7-26.2-7.7-26.8 0-48.7 21.8-48.7 48.7s21.8 48.7 48.7 48.7c26.8 0 48.7-21.8 48.7-48.7 0-9.6-2.8-18.6-7.7-26.2l57.6-57.6c4.1-4.1 4.1-10.7 0-14.8-4.1-4.1-10.8-4.1-14.9 0zM256 283.2c-15.3 0-27.7-12.4-27.7-27.7s12.4-27.7 27.7-27.7 27.7 12.4 27.7 27.7-12.4 27.7-27.7 27.7z'
    },
    {
      d:
        'M333.3 337.6H171.6c-5.8 0-10.5 4.7-10.5 10.5s4.7 10.5 10.5 10.5h161.7c5.8 0 10.5-4.7 10.5-10.5s-4.7-10.5-10.5-10.5z'
    }
  ],
  name: 'odometer',
  type: 'regular'
}
